const Utils = {
	debounce: (func, wait) => {
		let timeoutId = null;
		return (...args) => {
			window.clearTimeout(timeoutId);
			timeoutId = window.setTimeout(() => {
				func.apply(null, args);
			}, wait);
		};
	},

	hasTouch: () => {
		return window.matchMedia('(pointer: coarse)').matches;
	},
};

export default Utils;
